import React from "react";
// import RcSelect, { Option, OptGroup } from '../../_rc-select-6.4.8';
import classNames from "classnames";
import Loadable from "../../react-loadable";
const RcSelect = Loadable({
  loader: () => import("../../_rc-select-6.4.8"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const Option = Loadable({
  loader: () => import("../../_rc-select-6.4.8/src/Option"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
import OptGroup from "../../_rc-select-6.4.8/src/OptGroup"; // OptGroup异步会影响组件正常使用
export default class Select extends React.Component {
  static Option = Option;
  static OptGroup = OptGroup;

  static defaultProps = {
    prefixCls: "ant-select",
    transitionName: "slide-up",
    choiceTransitionName: "zoom",
    showSearch: false
  };

  static contextTypes = {
    antLocale: React.PropTypes.object
  };

  render() {
    let {
      size,
      className,
      combobox,
      notFoundContent,
      prefixCls,
      showSearch,
      optionLabelProp
    } = this.props;

    const cls = classNames({
      [`${prefixCls}-lg`]: size === "large",
      [`${prefixCls}-sm`]: size === "small",
      [className]: !!className,
      [`${prefixCls}-show-search`]: showSearch
    });

    const { antLocale } = this.context;
    if (antLocale && antLocale.Select) {
      notFoundContent = notFoundContent || antLocale.Select.notFoundContent;
    }

    if (combobox) {
      notFoundContent = null;
      // children 带 dom 结构时，无法填入输入框
      optionLabelProp = optionLabelProp || "value";
    }

    return (
      <RcSelect
        {...this.props}
        ref="rcSelect"
        className={cls}
        optionLabelProp={optionLabelProp || "children"}
        notFoundContent={notFoundContent}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/select/index.jsx